module.exports = __webpack_public_path__ + "static/media/loader.ecd117c0.gif";